import { DynamicAttributeFieldList } from "@/shared/dynamic-attributes/ui/dynamic-attribute-field-list/dynamic-attribute-field-list";
import { useFilterMeta } from "../model/use-filter-meta";
import { useMetaFilterConfig } from "../model/meta-filter-config";

export function OnlyPrimary() {
  const meta = useFilterMeta();
  const config = useMetaFilterConfig();

  if (!config?.primary) {
    return null;
  }

  return (
    <DynamicAttributeFieldList name="filters" meta={meta}>
      {(meta, { getNameByAttributeCode }) => (
        <>
          {meta.attributes.map((attr) => (
            <DynamicAttributeFieldList.FormItem
              key={attr.id}
              name={getNameByAttributeCode(attr.attributeCode)}
              hidden={attr.attributeCode !== config?.primary}
            >
              <DynamicAttributeFieldList.ControlProps
                placeholder={attr.name.value}
              >
                <DynamicAttributeFieldList.Item attributeMeta={attr} />
              </DynamicAttributeFieldList.ControlProps>
            </DynamicAttributeFieldList.FormItem>
          ))}
          {meta.groups.map((group) => (
            <>
              {group.attributes.map((attr) => (
                <DynamicAttributeFieldList.FormItem
                  key={attr.id}
                  name={getNameByAttributeCode(attr.attributeCode)}
                  hidden={attr.attributeCode !== config?.primary}
                >
                  <DynamicAttributeFieldList.ControlProps
                    placeholder={attr.name.value}
                  >
                    <DynamicAttributeFieldList.Item attributeMeta={attr} />
                  </DynamicAttributeFieldList.ControlProps>
                </DynamicAttributeFieldList.FormItem>
              ))}
            </>
          ))}
        </>
      )}
    </DynamicAttributeFieldList>
  );
}
